const ReviewFreePrice = () => {
  return (
    <div className='flex flex-col'>
      <span>Produto gratuito.</span>
    </div>
  );
};

export default ReviewFreePrice;
